/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CountryDto } from './CountryDto';
import {
    CountryDtoFromJSON,
    CountryDtoFromJSONTyped,
    CountryDtoToJSON,
    CountryDtoToJSONTyped,
} from './CountryDto';

/**
 * 
 * @export
 * @interface CountriesResponseDto
 */
export interface CountriesResponseDto {
    /**
     * List of countries
     * @type {Array<CountryDto>}
     * @memberof CountriesResponseDto
     */
    data: Array<CountryDto>;
    /**
     * Total number of countries
     * @type {number}
     * @memberof CountriesResponseDto
     */
    total: number;
}

/**
 * Check if a given object implements the CountriesResponseDto interface.
 */
export function instanceOfCountriesResponseDto(value: object): value is CountriesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function CountriesResponseDtoFromJSON(json: any): CountriesResponseDto {
    return CountriesResponseDtoFromJSONTyped(json, false);
}

export function CountriesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountriesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CountryDtoFromJSON)),
        'total': json['total'],
    };
}

export function CountriesResponseDtoToJSON(json: any): CountriesResponseDto {
    return CountriesResponseDtoToJSONTyped(json, false);
}

export function CountriesResponseDtoToJSONTyped(value?: CountriesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(CountryDtoToJSON)),
        'total': value['total'],
    };
}

